import React, { useEffect, useState } from 'react';
import { FiSearch } from 'react-icons/fi';
import LoadingPage from '../Loading/loading';
import { doneMedia, getMediaDone, hideRequestMedia, rejectMedia } from '../../api/media_buying';
import { Cookies } from 'react-cookie';

const MediaBuyingComponent = (props) => {
    const cookie = new Cookies();
    const [isSuper, setIsSuper] = useState(cookie.get("isSuper"));
    const [mediaBuyings, setMediaBuyings] = useState(null);
    const [removeId, setRemoveID] = useState("");
    const [hideId, setHideId] = useState("")
    useEffect(() => {
        getMediaDone(props.status).then((result) => {
            setMediaBuyings(result.data.response)
        })
    }, [])

    const done = (id) => {
        doneMedia(id).then((result) => {
            setMediaBuyings(mediaBuyings.filter(mediaBuying => mediaBuying._id !== id));
        })
    };

    const mediaReject = (id) => {
        rejectMedia(id).then((result) => {
            setMediaBuyings(mediaBuyings.filter(mediaBuying => mediaBuying._id !== id));
        })
    };

    const hide = (id) => {
        hideRequestMedia(id).then((result) => {
            getMediaDone(props.status).then((result) => {
                setMediaBuyings(result.data.response)
            })
            setHideId("")
        })
    };

    return (
        <>{mediaBuyings === null ? <LoadingPage /> : <div>
            <div>Number of Media is {mediaBuyings.length}</div>
            <div className="card-cards">
                {mediaBuyings?.map(mediaBuying => (
                    <div key={mediaBuying._id} className={`card-card`}>
                        <div className="card-info">
                            <div>
                                <p className='line'><span className="label">Name:</span> {mediaBuying?.user_id?.name}</p>
                                <p className='line'><span className="label">Phone from user data:</span> {mediaBuying?.user_id?.phone}</p>
                                <p className='line'><span className="label">Phone from message:</span> {mediaBuying.phone}</p>
                                <p className='line'><span className="label">Create at:</span> {mediaBuying?.createdAt.split("T")[0]}</p>
                                <p className='line'><span className="label">Message:</span> {mediaBuying.message}</p>
                                {(hideId === mediaBuying._id) && < div style={{
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                    padding: "5px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>
                                    <p className='line'>Are you sure you want to delete this? </p>
                                    <div className="card-info">
                                        <div className="card-actions">
                                            <button
                                                onClick={() => { setHideId("") }}
                                                className="action-btn accept-btn"
                                            >
                                                No
                                            </button>
                                        </div>
                                        <div className="card-actions">
                                            <button
                                                onClick={() => {
                                                    hide(mediaBuying._id)
                                                }}
                                                className="action-btn remove-btn"
                                            >
                                                Yes
                                            </button>
                                        </div>
                                    </div>
                                </div>}
                            </div>
                        </div>

                        <div>
                            {isSuper && <>{props.status === "New" && (
                                <div className="card-actions">
                                    <button
                                        onClick={() => { done(mediaBuying._id) }}
                                        className="action-btn accept-btn"
                                    >
                                        Done
                                    </button>
                                    <button
                                        onClick={() => { mediaReject(mediaBuying._id) }}
                                        className="action-btn remove-btn"
                                    >
                                        Reject
                                    </button>
                                </div>
                            )}</>}
                            <div style={{ height: "10px" }}></div>
                            {isSuper && hideId === "" && (props.status === "Accept" || props.status === "Reject") && <button
                                onClick={() => {
                                    setHideId(mediaBuying._id)
                                }}
                                className="action-btn remove-btn"
                            >
                                Delete
                            </button>}
                        </div>
                    </div>
                ))}
            </div>
        </div>}</>
    );
};

export default MediaBuyingComponent;